import { DialogMessage } from "@plugins-fr/dialogMessage";
import Lang from "@vendors-fr/messages";
import { ReservableProducts } from "@plugins-fr/reservableProducts";
import { getParams, shippingCostDisplay } from "@plugins-fr/payment";
import { setCartItem } from "@plugins-fr/script";
import {getProductCustomFieldsAndRefreshRender} from "@plugins-fr/CustomFields";

export class ReservableProductEventToggle {
    defaultOptions = {
        'mobileSpecificationToggleClass': '.js_update_reservable_product_mobile',
        'cartItemClass': '.js_cart_item_list',
        'cartItemQuantityClass': '.js_cart_list_quantity',
        'cartItemStandardClass': '.js_update_reservable_product'
    }

    constructor(cartListDom, mobilePushBlockDom, jsVarsThemeStyle, options) {
        this.cartListDom = cartListDom;
        this.mobilePushBlockDom = mobilePushBlockDom;
        this.options = Object.assign({}, this.defaultOptions, options);
        this.jsVarsThemeStyle = jsVarsThemeStyle;
    }

    bindEvents() {
        this.bindDesktopChangeProductStandardEvent();
        this.bindMobileClickProductsStandardToggleEvent();
    }

    // 更改服務商品場次(桌機版)
    bindDesktopChangeProductStandardEvent() {
        const _this = this;

        _this.cartListDom.on('click', _this.options.cartItemStandardClass, function () {
            const productId = $(this).data('product-id');
            const originalStandardId = $(this).data('standard-id');
            const originalReservableDate = $(this).data('reservable-date');
            const originalReservableEventId = $(this).data('reservable-event-id');
            const originalQuantity = $(this).data('quantity');

            new DialogMessage({
                'columnClass': 'col-xl-5 col-lg-6 col-md-8',
                'title': false,
                'icon': '',
                'theme': 'el_confirm el_modal_same ',
                'keyboardEnabled': true,
                'errorMessage': '<div class="title d-flex align-items-center p-0"><i class="icon-new_exclaim_circle"></i><span>' + Lang.get('frontend.product.listingcart.ajaxError') + '</span></div>',
                draggable: false,
                onContentReady: function () {
                    let response = this.ajaxResponse.data;
                    if (!response.status) {
                        return false;
                    }

                    const quantityDom = this.$content.find('.js_reservation_quantity_select');
                    const mobileQuantityDom = this.$content.find('.js_reservation_quantity_input');
                    const successBtnDom = this.$content.find('.js_btn_success_change');
                    const cancelBtnDom = this.$content.find('.js_btn_close_change');
                    const errorDom = this.$content.find('.js_reservation_error');

                    const reservableProducts = new ReservableProducts(this.$content, {
                        'reservationDates': response.reservationDates,
                        'productDisplayPrices': response.productDisplayPrices,
                        'reservableProductEventsMap': response.reservableProductEventsMap
                    }, {
                        'priceClass': '.js_price_area'
                    });
                    reservableProducts.updatePrice = () => {
                        const displayPrice = reservableProducts.getDisplayPrice();

                        let priceHTML = '';
                        if (displayPrice.displayBothPrices) {
                            priceHTML += '<div class="product_sale d-flex flex-column text-right">';
                            priceHTML += '<sub class="txt_origin" translate="no"><b class="font_montserrat line_through">' + response.customCurrency + '&ensp;' + response.currencyIcon + displayPrice.price + '</b></sub>';
                            priceHTML += '<h2 class="txt_sale" translate="no"><b class="font_montserrat">' + response.customCurrency + '&ensp;' + response.currencyIcon + displayPrice.realPrice + '</b></h2>';
                            priceHTML += '</div>';
                        } else {
                            priceHTML += '<div class="product_origin d-flex flex-column">';
                            priceHTML += '<h2 class="txt_sale txt_origin" translate="no"><b class="font_montserrat">' + response.customCurrency + '&ensp;' + response.currencyIcon + displayPrice.realPrice + '</b></h2>';
                            priceHTML += '</div>';
                        }

                        reservableProducts.priceDom.html(priceHTML);
                    };
                    reservableProducts.bindEvents();
                    reservableProducts.init();
                    reservableProducts.setStandardId(originalStandardId);
                    reservableProducts.setDefaultReservableDatetime(originalReservableDate, originalReservableEventId, originalQuantity);


                    // 點擊確定
                    successBtnDom.off('click');
                    successBtnDom.click(() => {

                        errorDom.addClass('d-none');

                        if (reservableProducts.getReservationDate() === '') {
                            errorDom.removeClass('d-none');
                            return false;
                        }

                        if (reservableProducts.getReservationEventId() === 0) {
                            errorDom.removeClass('d-none');
                            return false;
                        }

                        _this.changeCartReservableItemAction(productId, reservableProducts, quantityDom.is(":visible") ? quantityDom.val() : mobileQuantityDom.val(), originalReservableEventId, originalReservableDate);
                        this.close();
                    });

                    // 點擊取消
                    cancelBtnDom.click(() => {
                        this.close();
                    });

                    this.$el.find('.js_btn_success_change, .js_btn_close_change').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );

                    $('#js_mask_cover').hide();
                    setTimeout(function () {
                        $('#js_mask_cover').show();
                    }, 1000);
                },
                'content': function () {
                    let self = this;
                    return $.ajax({
                        url: productListingCartUrl,
                        dataType: 'json',
                        method: 'POST',
                        data: {
                            'productId': productId,
                            'action': 'changeReservableProduct',
                        }
                    }).done(function (response) {

                        if (!response.status) {
                            self.setContentAppend(self.errorMessage);
                            return false;
                        }

                        let contentDom = $(response.view);
                        self.setContentAppend(contentDom);

                    }).fail(function () {
                        self.setContentAppend(self.errorMessage);
                    });
                }
            }, {
                'autoClose': false
            }).handle();

        });
    }

    // 觸發顯示更改場次的彈窗(手機版)
    bindMobileClickProductsStandardToggleEvent() {
        const _this = this;

        _this.cartListDom.on('click', _this.options.mobileSpecificationToggleClass, function () {
            const productId = $(this).data('product-id');
            const originalStandardId = $(this).data('standard-id');
            const originalReservableDate = $(this).data('reservable-date');
            const originalReservableEventId = $(this).data('reservable-event-id');
            const originalQuantity = $(this).data('quantity');

            new DialogMessage({
                'columnClass': 'col-xl-5 col-lg-6 col-md-8',
                'title': false,
                'icon': '',
                'theme': 'el_confirm el_modal_same ',
                'keyboardEnabled': true,
                'errorMessage': '<div class="title d-flex align-items-center p-0"><i class="icon-new_exclaim_circle"></i><span>' + Lang.get('frontend.product.listingcart.ajaxError') + '</span></div>',
                draggable: false,
                onContentReady: function () {
                    let response = this.ajaxResponse.data;
                    if (!response.status) {
                        return false;
                    }

                    const quantityDom = this.$content.find('.js_reservation_quantity_select');
                    const mobileQuantityDom = this.$content.find('.js_reservation_quantity_input');
                    const successBtnDom = this.$content.find('.js_btn_success_change');
                    const cancelBtnDom = this.$content.find('.js_btn_close_change');
                    const errorDom = this.$content.find('.js_reservation_error');

                    const reservableProducts = new ReservableProducts(this.$content, {
                        'reservationDates': response.reservationDates,
                        'productDisplayPrices': response.productDisplayPrices,
                        'reservableProductEventsMap': response.reservableProductEventsMap
                    }, {
                        'priceClass': '.js_price_area'
                    });
                    reservableProducts.updatePrice = () => {
                        const displayPrice = reservableProducts.getDisplayPrice();

                        let priceHTML = '';
                        if (displayPrice.displayBothPrices) {
                            priceHTML += '<div class="product_sale d-flex flex-column text-right">';
                            priceHTML += '<sub class="txt_origin" translate="no"><b class="font_montserrat line_through">' + response.customCurrency + '&ensp;' + response.currencyIcon + displayPrice.price + '</b></sub>';
                            priceHTML += '<h2 class="txt_sale" translate="no"><b class="font_montserrat">' + response.customCurrency + '&ensp;' + response.currencyIcon + displayPrice.realPrice + '</b></h2>';
                            priceHTML += '</div>';
                        } else {
                            priceHTML += '<div class="product_origin d-flex flex-column">';
                            priceHTML += '<h2 class="txt_sale txt_origin" translate="no"><b class="font_montserrat">' + response.customCurrency + '&ensp;' + response.currencyIcon + displayPrice.realPrice + '</b></h2>';
                            priceHTML += '</div>';
                        }

                        reservableProducts.priceDom.html(priceHTML);
                    };
                    reservableProducts.bindEvents();
                    reservableProducts.init();
                    reservableProducts.setStandardId(originalStandardId);
                    reservableProducts.setDefaultReservableDatetime(originalReservableDate, originalReservableEventId, originalQuantity);

                    // 開啟日期設定
                    const $mobilepayContent = $('.js_mobilepay_content')
                    $mobilepayContent.find('.js_mobile_reservation_date').html("");
                    $mobilepayContent.find('div.js_mobile_reservation_date_form').removeClass('mobile_reservation_date_form--selected');
                    $('.js_mobile_reservation_calendar').show();

                    $mobilepayContent.find('.js_mobile_reservation_event').html("");
                    $mobilepayContent.find('div.js_mobile_reservation_events_form').removeClass('mobile_reservation_events_form--selected');
                    $mobilepayContent.find('div.js_mobile_reservation_events_form').hide();

                    $mobilepayContent.find('.js_mobile_reservation_quantity').hide()

                    $mobilepayContent.css('bottom', '0');
                    $mobilepayContent.nextAll('div.js_mobile_reservation_total').hide();
                    $mobilepayContent.nextAll('div.js_mobile_reservation_payButton').hide();

                    $mobilepayContent.find('div.js_mobile_reservation_total').removeClass('mobile_display'); //彈出視窗用，僅手機板顯示
                    $mobilepayContent.find('div.js_mobile_reservation_btn_area').hide(); //彈出視窗用

                    // 點擊確定
                    successBtnDom.off('click');
                    successBtnDom.click(() => {

                        errorDom.addClass('d-none');

                        if (reservableProducts.getReservationDate() === '') {
                            errorDom.removeClass('d-none');
                            return false;
                        }

                        if (reservableProducts.getReservationEventId() === 0) {
                            errorDom.removeClass('d-none');
                            return false;
                        }

                        _this.changeCartReservableItemAction(productId, reservableProducts, quantityDom.is(":visible") ? quantityDom.val() : mobileQuantityDom.val(), originalReservableEventId, originalReservableDate);
                        this.close();
                    });

                    // 點擊取消
                    cancelBtnDom.click(() => {
                        this.close();
                    });

                    this.$el.find('.js_btn_success_change, .js_btn_close_change').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );

                    $('#js_mask_cover').hide();
                    setTimeout(function () {
                        $('#js_mask_cover').show();
                    }, 1000);
                },
                'content': function () {
                    let self = this;
                    return $.ajax({
                        url: productListingCartUrl,
                        dataType: 'json',
                        method: 'POST',
                        data: {
                            'productId': productId,
                            'action': 'changeReservableProduct',
                        }
                    }).done(function (response) {

                        if (!response.status) {
                            self.setContentAppend(self.errorMessage);
                            return false;
                        }

                        let contentDom = $(response.view);
                        self.setContentAppend(contentDom);

                    }).fail(function () {
                        self.setContentAppend(self.errorMessage);
                    });
                }
            }, {
                'autoClose': false
            }).handle();
        });
    }

    changeProductCustomFields() {
        getProductCustomFieldsAndRefreshRender({
            url: productCustomFieldsUrl,
            isMobile: typeof is_mobile !== 'undefined' && is_mobile === 1
        });
    }

    changeCartReservableItemAction(productId, reservableProducts, quantity, originalReservableEventId, originalReservableDate) {
        let params = getParams();

        let action = 'update_reservable_item_quantity';
        params.qty = quantity;
        params.standard_id = reservableProducts.getStandardId();
        params.product_id = productId;
        params.date = reservableProducts.getReservationDate();
        params.reservable_products_events_id = reservableProducts.getReservationEventId();

        // 有異動場次時間才視為改規格，否則只視為改數量
        if (originalReservableEventId !== params.reservable_products_events_id || originalReservableDate !== params.date) {
            action = 'update_reservable_item_events';
            params.origin_standard_id = reservableProducts.getStandardId();
            params.origin_reservable_products_events_id = originalReservableEventId;
            params.origin_date = originalReservableDate;
        }

        const setCartItemCallBack = (data) => {
            shippingCostDisplay(data)
            this.changeProductCustomFields();
        }

        setCartItem(action, params, setCartItemCallBack, false);
    }
}
